// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1tjnT","title":"Images45_title__25Zlu","images":"Images45_images__28bsi"};